import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueService } from '../services/issue.service';

@Pipe({
  name: 'issue'
})
export class IssuePipe implements PipeTransform {

  constructor(private _issueService: IssueService){ }

  transform(identifier: number): Observable<string> {
    return this._issueService.getIssueById(identifier, true).pipe(map(x => [x.issuenumber, x.issuetitle].filter(x => x? true: false).join(' ')));
  }

}
